import * as t from '../actionTypes'
import axios from 'utils/axios'
import { guardFromErrors, extractErrorInfo } from 'utils/graphqlHelpers'
import { PostmarkSetting } from '../types'

export type FetchPostmarkSettingsForOptionsAction = FSA<undefined, PostmarkSetting[], string>
type FetchPostmarkSettingsForOptions = (searchText?: string) => MrxThunk<FetchPostmarkSettingsForOptionsAction>
type QueryResponse = GraphQLResponse<'postmarkSettingsForOptions', PostmarkSetting[]>

const FETCH_POSTMARK_SETTINGS_FOR_OPTIONS = `
  query fetchPostmarkSettingsForOptions ($workspaceId: Int!, $limit: Int, $searchText: String) {
    postmarkSettingsForOptions (workspaceId: $workspaceId, limit: $limit, searchText: $searchText) {
      id
      name
    }
  }
`

const fetchPostmarkSettingsForOptions: FetchPostmarkSettingsForOptions = (searchText) => async (dispatch, getState) => {
  dispatch({
    type: t.FETCH_POSTMARK_SETTINGS_FOR_OPTIONS,
    meta: { done: false }
  })

  try {
    const {
      workspaces: {
        activeWorkspace: { id: workspaceId }
      }
    } = getState()
    const {
      data: { data, errors }
    }: QueryResponse = await axios.post('/graphql', {
      query: FETCH_POSTMARK_SETTINGS_FOR_OPTIONS,
      variables: { workspaceId, searchText }
    })

    guardFromErrors(errors)

    if (!data) {
      throw new Error('Response body is empty!')
    }

    const { postmarkSettingsForOptions } = data
    if (!postmarkSettingsForOptions) {
      throw new Error("Can't get Postmark settings!")
    }

    dispatch({
      type: t.FETCH_POSTMARK_SETTINGS_FOR_OPTIONS,
      payload: postmarkSettingsForOptions,
      meta: { done: true }
    })
  } catch (err) {
    dispatch({
      type: t.FETCH_POSTMARK_SETTINGS_FOR_OPTIONS,
      payload: extractErrorInfo(err),
      error: true
    })
  }
}

export { fetchPostmarkSettingsForOptions }
